export default __webpack_public_path__ + "images/e4e43ce1760eb57fced0bf6891e4a6d7.png";